function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { default as React, useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import RateModal from '@components/modals/RateModal';
import { Table } from '@rd-web-markets/shared/dist/util';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch } from 'react-redux';
import { LOCALE } from '@rd-web-markets/market/dist/constants';
import VirtualizedTable from '../util/Table/VirtualizedTable';

/**
 * Renders a rate card which contains table with a row for each rate.
 *
 * E.g.
 *    {
 *      title: 'Surrender Rates',
 *      rates: [ { id: 'Number', start_date: 'DATE', rate: 'Number' }]
 *    }
 *
 * @param String title
 * @param Array rates
 * @param Object service - to handle create/edit/delete callbacks
 * @returns
 */
export default function Rate(_ref) {
  let {
    title,
    rates,
    service,
    onChange
  } = _ref;
  const currencyFormatter = new Intl.NumberFormat(LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const rateFormattedValue = rate => {
    if (title === 'NI Thresholds') {
      return [currencyFormatter.format(rate.threshold)];
    } else if (title === 'R&D SME Scheme') {
      return ["".concat(rate.enhanced_deduction, "%"), "".concat(rate.payable_credit, "%")];
    } else if (title === 'R&D Expenditure Credit (RDEC) Scheme') {
      return ["".concat(rate.payable_credit, "%")];
    } else if (title === 'R&D Intensive SME (Loss-making)') {
      return ["".concat(rate.intensity_threshold, "%"), "".concat(rate.payable_credit, "%")];
    } else {
      return ["".concat(rate.rate, "%")];
    }
  };
  const formattedRateType = rateType => rateType === 'sme' ? 'SME' : 'RDEC';
  const typeColumnExists = title => {
    if (title === 'Surrender Rates' || title === 'Credit Rates') {
      return 'Type';
    } else {
      return '';
    }
  };
  function ratesToTableRows(rates) {
    return rates.map(rate => ({
      columns: [rate.start_date, ...rateFormattedValue(rate)]
    }));
  }
  const dispatch = useDispatch();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [rateToEdit, setRateToEdit] = useState(null);
  const styles = {
    header: {
      fontSize: '16.8px'
    },
    scrollableContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '300px',
      maxHeight: '300px'
    }
  };
  const headers = title => {
    const headersArray = [];
    if (title === 'NI Thresholds') {
      headersArray.push({
        text: 'End Date'
      }, {
        text: 'Threshold'
      }, {
        text: typeColumnExists(title)
      });
    } else if (title === 'R&D SME Scheme') {
      headersArray.push({
        text: 'Date'
      }, {
        text: 'Enhanced deduction'
      }, {
        text: 'Payable credit'
      });
    } else if (title === 'R&D Expenditure Credit (RDEC) Scheme') {
      headersArray.push({
        text: 'Date'
      }, {
        text: 'Payable credit'
      });
    } else if (title === 'R&D Intensive SME (Loss-making)') {
      headersArray.push({
        text: 'Date'
      }, {
        text: 'Intensity threshold'
      }, {
        text: 'Payable credit'
      });
    } else {
      headersArray.push({
        text: 'Start Date'
      }, {
        text: 'Rate'
      }, {
        text: typeColumnExists(title)
      });
    }
    return headersArray;
  };
  const editModal = rateToEdit => {
    if (!rateToEdit) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    return /*#__PURE__*/React.createElement(RateModal, {
      title: title,
      editDate: rateToEdit.start_date,
      editRate: rateToEdit,
      editRateType: rateToEdit.rate_type,
      show: !!rateToEdit,
      isPercentage: title !== 'NI Thresholds',
      onHide: () => setRateToEdit(null),
      onSubmit: async (start_date, rateValue, type) => {
        rateToEdit = _objectSpread(_objectSpread(_objectSpread({}, rateToEdit), rateValue), {}, {
          start_date,
          rate_type: type
        });
        await service.update(rateToEdit);
        onChange();
      }
    });
  };
  const createModal = () => /*#__PURE__*/React.createElement(RateModal, {
    show: showCreateModal,
    title: title,
    isPercentage: title !== 'NI Thresholds',
    onHide: () => setShowCreateModal(false),
    onSubmit: async (date, rate) => {
      await service.create(date, rate);
      setShowCreateModal(false);
      onChange();
    }
  });
  const deleteConfirmation = rate => {
    if (window.confirm('Are you sure you wish to proceed? This action cannot be undone!')) {
      service.delete(rate).then(onChange).catch(err => dispatch(handleError(err.description)));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, createModal(), editModal(rateToEdit), /*#__PURE__*/React.createElement(Card, {
    className: "mb-5",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-primary bg-gradient text-white text-start",
    style: styles.header
  }, title), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "RateTableContainer",
    style: {
      height: '300px',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("style", null, "\n                .ReactVirtualized__Table__row {\n                  background-color: #f2f2f3;\n                  /* box-sizing: border-box; */\n                }\n\n                .Table-Cell-Spacer {\n                  height: 5px;\n                }\n              "), /*#__PURE__*/React.createElement(VirtualizedTable, {
    headerHeightPx: 50,
    headers: headers(title),
    rows: ratesToTableRows(rates),
    onDelete: i => deleteConfirmation(rates[i]),
    onEdit: i => setRateToEdit(rates[i]),
    rowMarginPixels: 2
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "w-100",
    size: "md",
    block: true,
    onClick: () => setShowCreateModal(true)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " Add ", title === 'NI Thresholds' ? 'Threshold' : 'Rate'))));
}